const LAST_SELECTED_PROFILES_KEY = 'beey_lastSelectedProfiles';
export const loadLastSelectedProfilesFromStorage = () => {
    try {
        const stored = window.localStorage.getItem(LAST_SELECTED_PROFILES_KEY);
        if (stored !== null && stored !== '') {
            const parsed = JSON.parse(stored);
            return new Map(Object.entries(parsed));
        }
    }
    catch (error) {
        // Silently fail if localStorage is not available or corrupted
    }
    return new Map();
};
export const saveLastSelectedProfilesToStorage = (profiles) => {
    try {
        const serialized = Object.fromEntries(profiles);
        window.localStorage.setItem(LAST_SELECTED_PROFILES_KEY, JSON.stringify(serialized));
    }
    catch (error) {
        // Silently fail if localStorage is not available or corrupted
    }
};
